import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import { reorderItemRedirect } from 'components/HighlightsPage/ProductItem/ProductItem';
import { setAddingProductToBasketAction } from 'store/app/slice';
import getHighlights from '../selector/getHighlights';

const autoReorderOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();

    const queryParams = new URLSearchParams(document.location.search);
    const orderItemId = Number(queryParams.get('orderItemId'));
    if (!orderItemId) return;

    const highlights = getHighlights(store);
    if (!highlights.length) return;

    let orderItem;
    highlights.some((order) => {
      return order.items.some((item) => {
        if (item.orderItemId === orderItemId) {
          orderItem = item;
          return true;
        }
        return false;
      });
    });
    if (!orderItem) return;

    const { encDesignId } = orderItem;
    dispatch(setAddingProductToBasketAction(true));
    setTimeout(() => {
      reorderItemRedirect(encDesignId);
    }, 300);
  };

export default autoReorderOperation;
